import { roundToDecimals } from 'helpers';

/**
 * Calculate the percentage change between two numbers.
 * @param previous The previous value.
 * @param latest The latest value.
 * @returns The percentage change or null if previous is zero to avoid division by zero.
 */
export const percentageChange = (previous: number, latest: number) => {
  if (latest === previous) {
    return 0;
  }

  if (previous === 0) {
    return null;
  }

  return ((latest - previous) / previous) * 100;
};

export const formatToPercentage = (percentage: number | null) => {
  if (percentage === null) {
    return '-';
  }
  const roundedPercentage = roundToDecimals(percentage, 2);
  return (roundedPercentage < 0 ? '' : '+') + roundedPercentage + '%';
};
